import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../api/queryKeys';
import { EMPTY_GUID } from '../../utils/string-utils';
import { Shift } from '../resourceTracking/types';
import { getBreakDisplay } from './api';

/**
 * Fetches whether the given cell + shift is currently on a scheduled break.
 *
 * Fetches once on mount (catches a break already in progress on page load), then refetches only when
 * the SignalR client invalidates QueryKeys.BREAK_DISPLAY on a break-start push — no continuous polling.
 */
export const useBreakDisplayQuery = (mCellId: string, shift: Shift) =>
  useQuery({
    queryKey: [QueryKeys.BREAK_DISPLAY, mCellId, shift],
    queryFn: () => getBreakDisplay(mCellId, shift),
    enabled:
      !!mCellId &&
      mCellId !== EMPTY_GUID &&
      shift !== 'None' &&
      shift !== 'Unknown' &&
      // 'Active' is a scoreboard filter value, not a real shift. Pages keep it out of the
      // app-wide shift setting, but a value stored before that guard existed can still surface
      // here, and it matches no schedule — so don't ask the server about it.
      shift !== ('Active' as Shift),
  });
